<template lang="pug">
  .records
    .page-header
      h2 CS:GO Surf
      select.flex-right(v-model="$route.params.map", @change="selectedMapChanged")
        template(v-for="map in maps")
          option {{ map }}

    h3 Leaderboards

    table(cellspacing="0", cellpadding="0")
      tr
        th Position
        th Time
        th.mobile-hide Map
        th Player

      tr(v-for="record, index of records")
        td {{ (index + 1) + ($route.params.page - 1) * 30 }}
        td {{ record.maptime | time }}
        td.mobile-hide {{ record.map }}
        td {{ record.playerName }}
        // router-link(:to="{ name: 'client', params: { id: record.b3Cid } }") {{ record.playerName }}

    pagination(:page="$route.params.page", :pages="pages", :uri="`/csgo-surf/records/${$route.params.map}/${$route.params.filter}/`")
</template>

<script>
import RecordsCSGOSurfService from '@/services/RecordsCSGOSurf';

import Pagination from '@/components/core/Pagination.vue';

export default {
  name: 'records-csgo-surf',
  components: {
    Pagination,
  },
  data() {
    return {
      records: [],
      pages: 1,
      maps: [],
    };
  },
  methods: {
    async init() {
      const response = await RecordsCSGOSurfService.getMaps();
      if (response.error) {
        console.log(response.error);
        return;
      }
      this.maps = response.data;

      this.update();
    },
    async update() {
      if (!this.$route.params.map) {
        const [map] = this.maps;
        this.$route.params.map = map;
      }

      if (!this.$route.params.page) {
        this.$route.params.page = 1;
      }

      const response = await RecordsCSGOSurfService.getRecords(this.$route.params.map, this.$route.params.page);
      console.log(response);
      if (response.error) {
        console.log(response.error);
        return;
      }

      this.records = response.data.records;
      this.pages = response.data.pages;
    },
    selectedMapChanged() {
      this.$router.push({
        name: 'records-csgo-surf',
        params: {
          map: this.$route.params.map,
          page: 1,
        },
      });
    },
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.update();
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 979px) {
  .records {
    .page-header {
      margin-bottom: 24px;

      select {
        width: 100%;
      }

      .button {
        top: 16px;
      }
    }
  }
}
</style>
